import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useStorefrontContext } from 'context/StorefrontContext';
import { getSiteName } from 'config/appConfig';
import { buildGoogleFontsStylesheetUrl, getGoogleFontFamiliesToLoad } from 'constants/storeFonts';
import { resolveStoreMediaUrl } from 'utils/themeDisplay';

const TenantHead: React.FC = () => {
  const { theme } = useStorefrontContext();
  const siteName = theme?.siteName?.trim() || getSiteName();
  const faviconUrl = resolveStoreMediaUrl(theme?.faviconUrl);
  const googleFontsUrl = buildGoogleFontsStylesheetUrl(getGoogleFontFamiliesToLoad(theme?.fontFamily));

  return (
    <Helmet>
      <title>{siteName}</title>
      {faviconUrl && <link rel="icon" href={faviconUrl} />}
      {googleFontsUrl && <link rel="preconnect" href="https://fonts.googleapis.com" />}
      {googleFontsUrl && <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />}
      {googleFontsUrl && <link rel="stylesheet" href={googleFontsUrl} />}
      <meta name="application-name" content={siteName} />
    </Helmet>
  );
};

export default TenantHead;
